import { isObject } from 'lodash'

export const registeredTabsHandlers = {}

export function registerHandlers (handlers) {
  if (handlers && isObject(handlers)) {
    Object.assign(registeredTabsHandlers, handlers)
  }
}

export function unregisterHandlers (key) {
  if (key && registeredTabsHandlers[key]) {
    delete registeredTabsHandlers[key]
  }
}
